<template>
    <nav class="navbar navbar-expand-sm bg-success py-2">
        <div class="container-fluid">
            <template v-if="$route.path == '/'">
                <RouterLink class="title" to="/">草加市小学生バドミントン連合</RouterLink>
            </template>
            <template v-else>
                <button class="title" @click="goBack" style="background: none; border: none; cursor: pointer;">
                    <font-awesome-icon :icon="['fas', 'arrow-left']" style="color: #32cd32;"/>&nbsp;&nbsp;草加市小学生 令和8年度 夏季大会
                </button>
            </template>
            <!-- <TourComponent/> -->

            <!-- Help icon for timetable page -->
            <span v-if="$route.path === '/timetable'" class="help-icon" @click="openTimetableHelp">
                <font-awesome-icon :icon="['fas', 'circle-question']" style="color: white; font-size: 1.2rem; cursor: pointer;"/>
            </span>

            <!-- <span>
                <RouterLink to="/ops/menu"><font-awesome-icon :icon="['fas', 'user-pen']"  style="color: white"/></RouterLink>
            </span>
            <span>
                <RouterLink to="/ops/menu"><font-awesome-icon :icon="['fas', 'user-gear']"  style="color: white"/></RouterLink>
            </span> -->
        </div>
    </nav>
</template>

<script setup>
import { RouterLink, RouterView, useRouter } from 'vue-router'
import { getAuth } from "firebase/auth";
const auth = getAuth();
const router = useRouter()
import TourComponent from '@/components/TourComponent.vue'

const goBack = () => {
  if (router.currentRoute.value.path === '/timetable') {
    router.back()
  } else {
    router.push('/')
  }
}

const openTimetableHelp = () => {
  window.open('/help/timetable.html', '_blank')
}

</script>

<style scoped>
.title {
    font-size: 15px;
    color: white;
    /* font-family:'メイリオ', 'Meiryo', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif; */
    font-weight: 500;
    text-decoration: none;
}

.help-icon {
    margin-left: auto;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.help-icon:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.help-icon:active {
    background-color: rgba(255, 255, 255, 0.2);
}

</style>